import React, { useEffect, useState } from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  required,
} from "react-admin";
import { parse } from "query-string";
import WebhookIntegrationTypes from "../../defaults/WebhookIntegrationTypes";
import OrgSelector from "../../components/OrgSelector";
import EventTypeSelector from "../../components/EventTypeSelector";

const WebhookCreate = (props) => {
  const { organization_id } = parse(props.location.search);

  return (
    <Create {...props}>
      <SimpleForm>
        <OrgSelector
          fullWidth
          source="org_id"
          org_id={organization_id}
          locked={organization_id}
          required
        />
        <TextInput
          fullWidth
          label="Destination"
          source="destination"
          validate={[required()]}
        />
        <TextInput fullWidth label="Delay" source="delay" />
        <SelectInput
          fullWidth
          label="Integration Type"
          source="integration_type"
          validate={[required()]}
          choices={WebhookIntegrationTypes}
        />
        <EventTypeSelector />
        <TextInput fullWidth label="Custom Fields" source="custom_fields" />
      </SimpleForm>
    </Create>
  );
};

export default WebhookCreate;
